



























import { Component, Vue, Prop, Inject } from 'vue-property-decorator'
import { productLinkUrl } from '@/app/core/utils'
import iconUserGold from '@/assets/images/search/icon-user_gold2.png'
import iconUserPregnant from '@/assets/images/search/icon-user_pregnant2.png'
import iconUserCertify from '@/assets/images/search/icon-user_certify2.png'

@Component({})
export default class BusinessItem extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: any

  @Inject('pageTrackParams')
  pageTrackParams!: any
  @Inject('clickid_200031')
  clickid_200031!: string

  get spuUserTag() {
    if (this.value.customerType == 1) {
      return iconUserGold
    } else if (this.value.customerType == 2) {
      return iconUserPregnant
    } else if (this.value.customerType == 3) {
      return iconUserCertify
    }
    return ''
  }

  get goDetail() {
    return productLinkUrl(this.value.linkUrl, 3)
  }

  goDetailClick = () => {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200031, positionParam: { name: this.value.spuName } })
  }
}
